<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        dark
        color="blue darken-1"
        block
        v-on="on"
      >
        Carry Over Leave Entitlement 
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Carry Over Leave Entitlement"
      text="Create Leave Entitlements For Next Year"
      class="mb-0"
    >
      <v-container>
        <v-card-title>
          <span class="headline">Are you sure?</span>
        </v-card-title>
        <v-card-text>
          This action will copy over all entitlements to next year. Any extra unused leave over the carry forward limit will be forfeited.
        </v-card-text>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submit"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        progressing: false,
      }
    },

    methods: {
      submit () {
        this.progressing = true

        this.$api.leaveEntitlements().createMany()
          .then((res) => {
            if (res.status === 200) {
              this.$emit('copied')             
              this.$snack({ message: res.data.status })

              this.dialog = false               
            }
          }).catch(error => {
            if (error.response.status === 500) {
              this.$snack({ 
                color: 'error',
                message: 'Failed to create leave entitlement', 
              })
            } else if (error.response.status === 423) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })
            } else if (error.response.status === 428) {
            } 
          }).then(() => {
            this.progressing = false
          })
      },
    },
  }
</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
    max-height: 100%;
}
</style>
